import axiosInstance from "../../axiosInstance";
import * as I from "./users.interface";

export const getUser = async (id: number): Promise<I.GetUserDataResponse> => {
  const response = await axiosInstance.get(`/api/v1.0/Usuarios/${id}`);
  return response.data;
};

export const getUsers = async (idPerfil: number): Promise<I.GetUsersResponse> => {
  const response = await axiosInstance.get("/api/v1.0/usuarios", {
    params: { idPerfil },
  });
  return response.data;
};

export const getUserProfiles = async (): Promise<I.ApiResponse<I.Profile[]>> => {
  const response = await axiosInstance.get("/api/v1.0/perfis", {
    params: { pageSize: 100 },
  });
  return response.data;
};

export const getUserSecretaries = async (): Promise<
  I.ApiResponse<I.Secretary[]>
> => {
  const response = await axiosInstance.get("/api/v1.0/secretarias", {
    params: { pageSize: 1000 },
  });
  return response.data;
};

export const getUserSpecials = async (): Promise<I.ApiResponse<I.Special[]>> => {
  const response = await axiosInstance.get(
    "/api/v1.0/Especializada/Ordernada",
    {
      params: {
        idSecretaria: 0,
        isBloqueado: false,
      },
    },
  );
  return response.data;
};

export const getUserAttorneys = async (): Promise<
  I.ApiResponse<I.Attorney[]>
> => {
  const response = await axiosInstance.get("/api/v1.0/procuradores", {
    params: { pageSize: 250 },
  });
  return response.data;
};

export const createUser = async (
  payload: I.UserPayload,
): Promise<I.MutationUserResponse> => {
  const response = await axiosInstance.post("/api/v1.0/usuarios", payload);
  return response.data;
};

export const updateUser = async (
  id: number,
  payload: I.UserPayload,
): Promise<I.MutationUserResponse> => {
  const response = await axiosInstance.put(`/api/v1.0/usuarios/${id}`, payload);
  return response.data;
};

export const deleteUserSector = async (
  id: number,
): Promise<I.ApiResponse<null>> => {
  const response = await axiosInstance.delete(
    `/api/v1.0/setores-usuarios/${id}`,
  );
  return response.data;
};

export const deleteUserAdvisorAttorney = async (
  id: number,
): Promise<I.ApiResponse<null>> => {
  const response = await axiosInstance.delete(
    `/api/v1.0/procuradores-assessores/${id}`,
  );
  return response.data;
};
